import { createSelector } from 'reselect';
import getCurrentOrder from './getCurrentOrder';

const getDayparts = createSelector(
  [getCurrentOrder],
  (currentOrder): DaypartMap => currentOrder.dayparts || {},
);

export default getDayparts;
